import { render } from "./HelloWorld.vue?vue&type=template&id=1935ec24&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=1935ec24&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/fantasy-nft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1935ec24"]])

export default __exports__